import React, {useState} from "react";
import {StyledEngineProvider, ThemeProvider} from '@mui/material/styles';
import {Grid, Theme, useTheme} from "@mui/material";
import {GridSize, GridSpacing} from "@mui/material/Grid/Grid";
import MUIDataTable, {MUIDataTableColumn, MUIDataTableOptions} from "mui-datatables";
import {muiDataTableTheme} from "./muiDataTableTheme";
import {muiDataTablesLabels} from "./muiDataTableTranslation";
import {useTranslation} from "react-i18next";
import {ResponsiveStyleValue} from "@mui/system";

export const contentPageStyle = (theme: Theme) => ({
  tableContainer: {
    flexGrow: 1,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  tableContainerItem: {
    flexGrow: 1,
    display: 'flex',
    border: '1px solid lightgrey',
    borderRadius: '4px',
  }
});

export function ContentPageTable<ENTITY>(props: {
  entities: ENTITY[],
  columns: MUIDataTableColumn[],
  rowHeight?: number,
  handleRowClick?: (entity: ENTITY) => void
  tableOptions?: MUIDataTableOptions,
  tableGridSize?: ResponsiveStyleValue<GridSpacing>,
}) {
  const {entities, columns, handleRowClick, tableOptions} = {...props}
  const theme = useTheme();
  const {t} = useTranslation();
  const [tableGridSize] = useState<ResponsiveStyleValue<GridSpacing>>(props.tableGridSize ?? {})

  function handleTableRowClick(rowData: string[], rowMeta: { dataIndex: number; rowIndex: number }) {
    handleRowClick && handleRowClick(entities[rowMeta.dataIndex]);
  }

  return (
    <Grid container={true} justifyContent="center" sx={contentPageStyle(theme).tableContainer}>
      <Grid item={true} xs={12} {...tableGridSize} sx={contentPageStyle(theme).tableContainerItem}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={muiDataTableTheme}>
            <MUIDataTable data={entities as Array<any> as Array<object>}
                          columns={columns}
                          title={''}
                          options={{
                            elevation: 2,
                            pagination: true,
                            rowsPerPage: 10,
                            rowsPerPageOptions: [10, 25, 100],
                            selectableRows: 'none',
                            search: false,
                            filter: false,
                            download: false,
                            print: false,
                            viewColumns: false,
                            responsive: 'standard',
                            onRowClick: handleTableRowClick,
                            textLabels: muiDataTablesLabels(t),
                            enableNestedDataAccess: '.',
                            ...tableOptions
                          }}
            />
          </ThemeProvider>
        </StyledEngineProvider>
      </Grid>
    </Grid>
  );
}
